import { Grid, Paper, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

const StyleTC = styled(Table)`
max-width: 90%;
/* width: 90%; */
/* min-width: 90%; */
border: 1px solid rgb(211, 211, 211);
margin: auto;
@media (min-width: ${props => props.theme.tabletBreakpoint}){
        /* margin-left: 5.5%; */
        max-width: 70%;
    }
`

const Detail = ({info}) => {

    const history = useHistory()
    const userInfo = useSelector(state => state.userInfo)

    const editHandler = (e) => {
        e.preventDefault()

        if (userInfo && userInfo.roles[0].role.name !== "MEMBER")
        history.push(`/event/${info.eventid}`)
    }

    return(
        <>
            <Grid container direction={"column"} spacing={8}>
                <br/>
                
            <StyleTC component={Paper} border={1} elevation={0}>
            <TableBody className="pointer">
                <TableRow key={info.eventid} onClick={editHandler}>
                    <TableCell style={{fontWeight: 'bold'}}>Event</TableCell>
                    <TableCell style={{ width: "100%" }}>{info.eventname}</TableCell>
                </TableRow>
                <TableRow key={info.eventid} onClick={editHandler}>
                    <TableCell style={{fontWeight: 'bold'}}>Date</TableCell>
                    <TableCell style={{ width: "100%" }}>{info.date}</TableCell>
                </TableRow>
                <TableRow key={info.eventid} onClick={editHandler}>
                    <TableCell style={{fontWeight: 'bold'}}>Description</TableCell>
                    <TableCell tyle={{ maxWidth: "2rem"}}>{info.description}</TableCell>
                </TableRow>
                <TableRow key={info.eventid} onClick={editHandler}>
                    <TableCell style={{fontWeight: 'bold'}}>Location</TableCell>
                    <TableCell>{info.location}</TableCell>
                </TableRow>
            </TableBody>
            {/* </Paper> */}
            </StyleTC>
                <Grid item></Grid>
            </Grid>
        </>    
    )
}

export default Detail;